import React from "react";
import { Box } from "@mui/material";
import logo from "../assets/logo.png";

const Logo = () => (
  <Box sx={{ height: 100, display: "flex", alignItems: "center", flexGrow: 1 }}>
    <img
      src={logo}
      alt="JifJaff Logo"
      style={{ height: 78, width: 90, marginRight: 8 }}
    />
  </Box>
);
export default Logo;
